import React from 'react'
import 'babel-polyfill'
import styled, { css } from 'styled-components'
import { inheritPrimaryColor } from '../colors'
import LatestPostSection from './latest-post'
import MeetTheTeam from './meet-the-team'
import { useScrollReset } from '../scroll'
import Tools from './tools'
// import Contact from './contact'
import { Link } from 'react-router-dom'

const preloadedNews = typeof window !== 'undefined' && window.__data__ && window.__data__.news

const Home = ({ data, ...props }) => {
  useScrollReset()

  const newsItem = data ? data.news[1][0] : preloadedNews[1][0]

  return (
    <div>
      <div css={`align-items: center; display: flex; flex-direction: column;`}>
        <div css={`margin: 70px 20px 20px; padding: 0px; text-align: right; padding-right: 20px; border-right: 10px solid ${inheritPrimaryColor}; max-width: 800px; line-height: 46px; font-weight: 200; font-size: 26px;`}>
          The Mutagenesis in Medicine team at University of Cambridge is
          devoted to studying <Emphasis>mutational signatures</Emphasis> and their implications in <Emphasis>cancer</Emphasis>,
          combining <Emphasis>computational</Emphasis> approaches with <Emphasis>experimental</Emphasis> and cancer data.
        </div>
        <Link to={`/research`} css={css`align-self: center; margin: 20px; margin-bottom: 70px; text-decoration: none; border-radius: 2px; transition: background-color 0.2s, color 0.2s; padding: 6px 12px; font-size: 1.2em; border: 3px solid ${inheritPrimaryColor}; background-color: ${inheritPrimaryColor}; color: white; font-weight: 500; &:hover {color: ${inheritPrimaryColor}; background-color: transparent;}`}>LEARN MORE</Link>
      </div>
      <LatestPostSection newsItem={newsItem} />
      <MeetTheTeam />
      <Tools />
      <Funders>
        {/* <h2 css='width: 100%; max-width: 1140px; text-align: center; margin: 0px; margin-top: 20px;color: rgb(190, 190, 190); font-weight: 100;'>Funding Partners</h2> */}
        <div css='display: flex; justify-content: center; flex-wrap: wrap;'>
          <Logo href='http://www.cam.ac.uk/' src='/public/cam.png' />
          <Logo href='https://www.cancerresearchuk.org/' src='/public/cruk.png' />
          <Logo href='https://wellcome.ac.uk/' src='/public/wellcome.png' />
          <Logo href='http://www.steinerstiftung.unibe.ch/' textArr={['Dr. Josef Steiner', 'Foundation']} />
          <Logo href='https://www.mrc-cu.cam.ac.uk/' src='/public/mrc.png' />
          <Logo href='https://www.ukrmp.org.uk/' src='/public/ukregen.png' />
        </div>
      </Funders>
      {/* <Contact /> */}
    </div>
  )
}
const Logo = styled(({ src, textArr, ...props }) => (
  <a target='_blank' {...props}>
    {src && <img src={src} css='height: 40px;' />}
    {textArr && <div css='height: 40px; display: flex; flex-direction: column; justify-content: center;'>
      {textArr.map((text, index) => <span key={index}>{text}</span>)}
    </div>}
  </a>
))`margin: 20px; text-decoration: none; color: grey`
const Emphasis = styled.span`
  color: ${inheritPrimaryColor};
  font-weight: 400;
  font-size: 34px;
`
const Funders = styled.div`
  background-color: rgb(245, 245, 245);
  /*
  background-image: linear-gradient(to bottom, rgb(245, 245, 245), rgb(252, 252, 252), rgb(245, 245, 245));
  */
  border-top: 1px solid rgb(240, 240, 240);
  padding: 30px 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
`

export default Home